import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { RemarkContextType } from '@app/application/communication/types'

export type SetTalkingPointsSidebarOptionsPayload = {
  contextType: RemarkContextType
  contextId: number
  ledgerId: number
  clientMeetingId?: number
}

export const useTalkingPointsSidebarOptions = defineStore(
  'talkingPointsSidebarOptions',
  () => {
    const contextType = ref<RemarkContextType | null>(null)
    const contextId = ref<number>(0)
    const ledgerId = ref<number>(0)
    const clientMeetingId = ref<number | undefined>(undefined)

    const setOptions = (
      options: SetTalkingPointsSidebarOptionsPayload
    ): void => {
      contextType.value = options.contextType
      contextId.value = options.contextId
      ledgerId.value = options.ledgerId
      clientMeetingId.value = options.clientMeetingId || undefined
    }

    return {
      setOptions,
      contextType,
      contextId,
      ledgerId,
      clientMeetingId,
    }
  }
)
